import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';

import { AuthProfileState } from './auth-profile.state';
import { AuthTokenState } from './auth-token.state';

@State({
  name: 'auth',
  children: [AuthProfileState, AuthTokenState],
})
@Injectable()
export class AuthState {}
